/**
 * Zorgt voor het kunnen ontvangen van de pupils
 * id = group_index
 *
 * @history
 * 23 november 2022
 * Basis implementatie
 *
 */
import React from 'react';
import {useDroppable} from '@dnd-kit/core';

export function DroppablePupilsAll(props) {
    const {isOver, setNodeRef} = useDroppable({
        id: props.id,
        data:
            {
                group_index:props.group_index
            }
    });
    const style = {
       // color: isOver ? 'green' : undefined,
        width:"100%",
        height:"100%",
        float:"left",



    };


    return (
        <div ref={setNodeRef} style={style}>
            {props.children}
        </div>
    );
}
